import * as React from "react"
import Svg, { Rect, Path, Defs, LinearGradient, Stop } from "react-native-svg"

function SvgComponent() {
  return (
    <Svg
      width={120}
      height={120}
      viewBox="0 0 120 120"
      fill="none"
    >
      <Rect
        width={120}
        height={120}
        rx={9}
        fill="url(#paint0_linear_4982_4326)"
      />
      <Path
        d="M23.835 93.684V57.351l-1.333-7.333 2.067-4.067h9.933v2.867l.667.333 1.2-1c.8-.667 1.889-1.311 3.266-1.933 1.422-.667 3.067-1 4.934-1 3.955 0 7.044 1.266 9.266 3.8 2.267 2.533 3.4 6.533 3.4 12 0 4.088-.578 7.4-1.733 9.933-1.111 2.489-2.622 4.289-4.533 5.4-1.912 1.111-4.045 1.667-6.4 1.667-3.2 0-5.467-.245-6.8-.734l-1.934-.8v17.2h-12zm15.067-24.8c1.689 0 3.044-.6 4.067-1.8 1.066-1.2 1.6-3.022 1.6-5.466 0-2.4-.423-4.156-1.267-5.267-.844-1.111-2.089-1.667-3.733-1.667l-3.734 1.4v11.934l.667.466c.489.267 1.289.4 2.4.4zM83.698 78.151c-2.134 0-3.845-.2-5.134-.6-1.244-.356-2.155-.711-2.733-1.067l-.867-.6v1.667h-12V41.018l-1.4-6.667 1.4-4h12v10.733l-.666 7.534.666.333c.89-.845 1.978-1.645 3.267-2.4 1.334-.8 3.156-1.2 5.467-1.2 3.955 0 7.044 1.267 9.266 3.8 2.267 2.533 3.4 6.533 3.4 12 0 4.089-.577 7.4-1.733 9.933-1.111 2.49-2.622 4.29-4.533 5.4-1.911 1.111-4.045 1.667-6.4 1.667zm-5.667-9.133c1.733 0 3.111-.6 4.133-1.8 1.023-1.245 1.534-3.09 1.534-5.534 0-2.4-.422-4.133-1.267-5.2-.844-1.11-2.089-1.666-3.733-1.666l-3.733 1.4V68.15l.666.467c.489.266 1.289.4 2.4.4z"
        fill="#fff"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_4982_4326"
          x1={60}
          y1={0}
          x2={60}
          y2={120}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#0059D4" />
          <Stop offset={0.265625} stopColor="#004EBA" />
          <Stop offset={0.9999} stopColor="#013174" />
          <Stop offset={1} stopColor="#0059D4" stopOpacity={0} />
        </LinearGradient>
      </Defs>
    </Svg>
  )
}

export default SvgComponent